import { useState } from "react";

/** Copy text to the clipboard with brief "✓ Copied" feedback. */
export function CopyButton({ text, label = "Copy" }: { text: string; label?: string }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard unavailable (insecure context / denied) — no-op */
    }
  }

  return (
    <button className="btn ghost sm" onClick={() => void copy()}>
      {copied ? "✓ Copied" : label}
    </button>
  );
}
